import React from 'react'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
class AssignedBoatCaptain extends React.Component {
  state = {
    alloedCaptain_list: [],
  }
  componentDidMount() {
    this.getAllotedCaptain()
  }
  getAllotedCaptain = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/captain/owner-alloted-captains/${this.props.match.params.ownerId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            alloedCaptain_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  //   handleStatusChange = (sid) => {
  //     var isChecked = $("#Owner_active_status_" + sid);
  //     isChecked.prop("checked", !isChecked.prop("checked"));
  //     if (!isChecked.prop("checked") === true) {
  //       var status = true;
  //     } else {
  //       var status = false;
  //     }
  //     var that = this;
  //     var data = new URLSearchParams();
  //     // this.setState({ isSaving: true });
  //     data.append("active", status);
  //     data.append("OwnerShopId", sid);
  //     fetch(Constant.getAPI() + "/shop/toggleActive", {
  //       method: "post",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: localStorage.getItem("waves_ad_auth"),,
  //    "country_short_name": `${localStorage.getItem('countryShortName')}`
  //       },
  //       body: data,
  //     })
  //       .then(function (response) {
  //         return response.json();
  //       })
  //       .then(function (json) {
  //         if (json.success === true) {
  //           Swal.fire("Update Status!", "Status has been updated.", "success");
  //           that.getVendorsList();
  //         } else {
  //           Swal.fire({
  //             title: "Something went wrong. Try again after some Time.!",
  //             icon: "error",
  //             text: "",
  //             confirmButtonColor: "#3085d6",
  //             cancelButtonColor: "#d33",
  //             confirmButtonText: "Ok",
  //           });
  //         }
  //       });
  //   };
  render() {
    const columns = [
      {
        name: 'user_profile',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (user_profile) => {
            return (
              <img
                src={
                  user_profile !== undefined && user_profile !== null && user_profile !== {}
                    ? Constant.getImage() + user_profile
                    : './assets/images/icon.png'
                }
                className="img-fluid img-40"
                alt="tbl"
              />
            )
          },
        },
      },

      {
        name: 'first_name',
        label: 'Captain Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'email',
        label: 'email',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'Owner_active_status_' + tableMeta.rowData[5]}
                checked={is_active === true ? true : false}
                value={is_active}
                // onChange={this.handleStatusChange.bind(
                //   this,
                //   tableMeta.rowData[5]
                // )}
              />
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Captain Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Alloted Captain List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    {/* <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{" "}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Owner List</li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Alloted Captain List'}
                          className="table-responsive"
                          data={this.state.alloedCaptain_list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AssignedBoatCaptain
